import type { FunctionComponent } from "react";
import { Button, Flex, Box, Text, Image } from "theme-ui";
import { ExitButton } from "../Components/ExitButton";
import Logo from "../images/junction_circular_icon.png";
import Avatar from "react-avatar";

const TeamAvatar = Avatar as FunctionComponent<{
  size: string;
  round?: boolean;
  name?: string;
}>;

export const ConsentPage = ({
  onClose,
  isMobile,
  companyName,
  teamConfig,
  ...props
}) => {
  return (
    <Flex
      id="conentBlock"
      sx={{
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}
      p={4}
    >
      {!isMobile && (
        <Box sx={{ textAlign: "right", width: "100%" }}>
          <ExitButton onClose={onClose} />
        </Box>
      )}
      <Flex
        sx={{ flexDirection: "column", alignItems: "center", width: "100%" }}
      >
        {isMobile && (
          <Box
            sx={{
              textAlign: "right",
              width: "100%",
              paddingBottom: ["0%", "5%", "5%"],
            }}
          >
            <ExitButton onClose={onClose} />
          </Box>
        )}
        <Box sx={{ pb: 40 }}>
          <ul
            className="consent-avatar-list"
            style={{
              listStyleType: "none",
              margin: 0,
              padding: 0,
              display: "flex",
              alignItems: "center",
            }}
          >
            <li className="avatar-style avatar-style--company">
              {teamConfig?.logo ? (
                <Image src={teamConfig?.logo} alt="" />
              ) : (
                <Box
                  className="avatar-style--company-inner"
                  sx={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <TeamAvatar size="40px" round name={teamConfig?.name} />
                </Box>
              )}
            </li>
            <li className="avatar-style">
              <Image src={Logo} alt="Junction" />
            </li>
          </ul>
        </Box>
        <Box sx={{ textAlign: "center", maxWidth: 360, mx: "auto" }}>
          <Text sx={{ fontSize: 3, fontWeight: "heading", color: "text", lineHeight: 1.35, letterSpacing: "-0.02em" }}>
            <Text as="span" sx={{ fontWeight: "heading", color: "text" }}>
              {companyName}
            </Text>{" "}
            uses{" "}
            <Text as="span" sx={{ fontWeight: "heading", color: "text" }}>
              Junction
            </Text>{" "}
            to link your wearables data.
          </Text>
        </Box>

        <Box sx={{ marginTop: 4, width: "100%", maxWidth: 400 }}>
          <Box
            sx={{
              textAlign: "left",
              mb: 3,
              p: 3,
              bg: "surface",
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "border",
            }}
          >
            <Text sx={{ fontSize: 2, fontWeight: "medium", color: "text", mb: 2 }}>
              Secure
            </Text>
            <Text sx={{ fontSize: 2, fontWeight: "body", color: "textSecondary", lineHeight: 1.55 }}>
              Data is encrypted and stored in a compliant manner
            </Text>
          </Box>

          <Box
            sx={{
              textAlign: "left",
              p: 3,
              bg: "surface",
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "border",
            }}
          >
            <Text sx={{ fontSize: 2, fontWeight: "medium", color: "text", mb: 2 }}>
              Private
            </Text>
            <Text sx={{ fontSize: 2, fontWeight: "body", color: "textSecondary", lineHeight: 1.55 }}>
              Data is never sold to a third party. You’re in control of who has
              access to your records.
            </Text>
          </Box>
        </Box>
      </Flex>

      <Box
        sx={{
          width: "100%",
          flexShrink: 0,
          pb: "max(0px, env(safe-area-inset-bottom))",
        }}
      >
        <Text
          sx={{
            fontSize: 0,
            color: "textMuted",
            my: 3,
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          By selecting &quot;Continue&quot; you agree to the Junction End User{" "}
          <Text
            as="a"
            href="https://junction.com/privacy"
            target="_blank"
            rel="noreferrer"
            sx={{ color: "primary", fontWeight: "medium", cursor: "pointer" }}
          >
            Privacy Policy
          </Text>
          .
        </Text>
        <Button sx={{ width: "100%" }} onClick={() => props.nextStep()}>
          Continue
        </Button>
      </Box>
    </Flex>
  );
};
